import {createRef, useState} from "react";
import {apiUrl} from "../../services/BackendService";
import {get} from "../../services/BackendService";
import {RequireTier} from "../auth/RequireTier";

interface ApiTokenResponse {
  token: string;
}

const ApiPage = () => {
  const tokenExpiredInRef = createRef<HTMLSelectElement>();
  const [token, setToken] = useState("");

  const generateToken = async () => {
    const expireIn = parseInt(tokenExpiredInRef.current?.value || "30") * 60 * 60 * 24;
    const getTokenResponse = await get<ApiTokenResponse>(`/login/api-token?expire=${expireIn}`);
    setToken(getTokenResponse.token);
  };
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col">
            <h2>Api docs:</h2>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <a href={`${apiUrl}/swagger/`} className="btn btn-primary" target="_blank" rel="noreferrer">
              swagger
            </a>
          </div>
        </div>
        <RequireTier requiredTier="superadmin" policy="hide">
          <div>
            <div className="row pt-5">
              <div className="col">
                <h2>API token</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-2">Expire in</div>
              <div className="col-8">
                <select className="form-select" ref={tokenExpiredInRef}>
                  <option value="30">30 days</option>
                  <option value="60">60 days</option>
                  <option value="90">90 days</option>
                  <option value="180">180 days</option>
                  <option value="365">365 days</option>
                </select>
              </div>
              <div className="col-2">
                <button className="btn btn-primary" onClick={generateToken}>
                  Generate
                </button>
              </div>
            </div>
            {token && (
              <>
                <div className="row">
                  <div className="col font-weight-bold">Token:</div>
                </div>
                <div className="row py-3">
                  <div className="col text-break font-weight-bold">{token}</div>
                </div>
                <div className="row">
                  <div className="col">This token will be disappear after refresh, please save it</div>
                </div>
              </>
            )}
          </div>
        </RequireTier>
      </div>
    </>
  );
};

export default ApiPage;
